






























































import Vue from 'vue'
import OrderFlow from '@/product/components/OrderFlow.vue'
import HowToDesignModal from '@/product/components/HowToDesignModal.vue'
import EstimatedShippingDates from '@/product/components/EstimatedShippingDates.vue'
import EstimatedDeliveryDates from '@/product/components/EstimatedDeliveryDates.vue'
import ShippingNote from '@/product/components/ShippingNote.vue'
import Accordion from '@/common/components/Accordion.vue'
import BillDetail from '@/product/components/BillDetail.vue'

import { formatOneDecimal } from '@/common/utils/common'
import { ProductState, ProductEstimate, Prefecture } from '@/product/types'

export default Vue.extend({
  components: {
    OrderFlow,
    HowToDesignModal,
    EstimatedShippingDates,
    EstimatedDeliveryDates,
    ShippingNote,
    Accordion,
    BillDetail
  },
  data(): {
    prefectureId: string
    prefectures: readonly Prefecture[]
    calcTimeInterval: number | null
    timeLeft: string
    isShowHowToDesignModal: boolean
  } {
    return {
      prefectureId: '',
      prefectures: [],
      calcTimeInterval: null,
      timeLeft: '',
      isShowHowToDesignModal: false
    }
  },
  computed: {
    isMobileView(): boolean {
      return this.$store.state.isMobileView
    },
    storeSate(): ProductState {
      return this.$store.state as ProductState
    },
    estimate(): ProductEstimate {
      return (this.$store.state as ProductState).estimate
    }
  },
  methods:{
    formatOneDecimal,
    onCloseHowToDesignModal() {
      this.isShowHowToDesignModal = false
    }
  }
})
